var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gt-svg-icon',{attrs:{"icon-name":_vm.isFullscreen?'exit-fullscreen':'fullscreen'},on:{"click":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }